import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMusicinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "#000",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 17,
				cy: 48,
				rx: 7,
				ry: 6
			}),
			/* @__PURE__ */ _jsx("path", { d: "M24 47V17l26-5v30M24 25l26-5-26 5z" }),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 43,
				cy: 43,
				rx: 7,
				ry: 6
			})
		]
	})
});
export default SvgMusicinline;
